export enum TABS {
  SETTINGS = 'settings',
  ELIMINATIONS_QUESTION = 'do-you-need-to-eliminate-accounts',
  ELIMINATIONS = 'eliminations',
  COA_STRUCTURE = 'coa-structure',
  DAILY_FX_RATES = 'daily-fx-rates'
}

export const ORGS_MAX_LIMIT = 30;
